/**
 * This is an extract of mobile-detect
 * https://github.com/hgoebl/mobile-detect.js
 * MIT License (MIT)
 * Copyright (c) 2013 Heinrich Goebl
 */
const OSs = {
  AndroidOS: 'Android',
  BlackBerryOS: 'blackberry|\\bBB10\\b|rim tablet os',
  PalmOS: 'PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino',
  SymbianOS: 'Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b',
  WindowsMobileOS: 'Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;',
  WindowsPhoneOS: 'Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;',
  iOS: '\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia',
  MeeGoOS: 'MeeGo',
  MaemoOS: 'Maemo',
  JavaOS: 'J2ME/|\\bMIDP\\b|\\bCLDC\\b',
  webOS: 'webOS|hpwOS',
  badaOS: '\\bBada\\b',
  BREWOS: 'BREW',
};

/**
 * Test userAgent string against a set of rules and find the first matched key.
 *
 * @param {Object} rules (key is String, value is RegExp)
 * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
 * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
 * @private
 */
function findMatch(rules, userAgent) {
  const keys = Object.keys(rules);
  for (let i = 0; i < keys.length; i += 1) {
    if (new RegExp(rules[keys[i]]).test(userAgent)) {
      return keys[i];
    }
  }

  return null;
}

/**
 * Tries to identify the User-Agent. Returns NULL if unknown
 *
 * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
 * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
 */
function detectMobileOS(userAgent) {
  return findMatch(OSs, userAgent);
}

export default detectMobileOS;
